/* eslint-disable max-lines */
import {
  BEHAVIOR_OPTIONS,
  CurrentEnvironment,
  DOG_AGE_STAGE_OPTIONS,
} from 'root-constants'

export const enum Cohort {
  WOOFZ22_V9 = 'woofz22_v9',
  WOOFZ22_V4 = 'woofz22_v4',
  WOOFZ22_V4L = 'woofz22_v4l',
  WOOFZ22_V4T = 'woofz22_v4t',
  WOOFZ22_V4_WT = 'woofz22_v4_wt',
  WOOFZ_PN = 'woofz_pn',
  WOOFZ_ESA = 'woofz_esa',
  WOOFZ_WS2 = 'woofz_ws2',
  WOOFZ_VGS = 'woofz_vgs',
  WOOFZ_RFND3_ND = 'woofz_rfnd3_nd',
  WOOFZ_VC6 = 'woofz_vc6',
  WOOFZ22_V3 = 'woofz22_v3',
  WOOFZ_PT1 = 'woofz_pt1',
  WOOFZ_RFND3 = 'woofz_rfnd3',
  WOOFZ_PPP = 'woofz_ppp',
  WOOFZ_PPP_BL = 'woofz_ppp_bl',
  WOOFZ_PPP_WOOFY = 'woofz_ppp_woofy',
  WOOFZ_PUP = 'woofz_pup',
  WOOFZ_PUP_BL = 'woofz_pup_bl',
  WOOFZ_LOVE = 'woofz_love',
  WOOFZ_RT = 'woofz_rt',
  WOOFZ_LOVE_BL = 'woofz_love_bl',
  WOOFZ_INVX = 'woofz_invx',
  WOOFZ_EASTER_65 = 'woofz_easter_65',
  WOOFZ_EASTER_70 = 'woofz_easter_70',
  WOOFZ_EASTER_75 = 'woofz_easter_75',
  WOOFZ_EASTER_80 = 'woofz_easter_80',
  WOOFZ_S1_6_12 = 'woofz_s1_6_12',
  WOOFZ_S2_6_12 = 'woofz_s2_6_12',
  WOOFZ_S3_6_12 = 'woofz_s3_6_12',
  WOOFZ_K9 = 'woofz_k9',
  WOOFZ_NPDAY_65 = 'woofz_npday_65',
  WOOFZ_NPDAY_70 = 'woofz_npday_70',
  WOOFZ_NPDAY_75 = 'woofz_npday_75',
  WOOFZ_NPDAY_80 = 'woofz_npday_80',
  WOOFZ_K9_BL = 'woofz_k9_bl',
  WOOFZ_K9_BL_1 = 'woofz_k9_bl_1', // OCS testing cohort
  WOOFZ_K9_BL_2 = 'woofz_k9_bl_2', // OCS testing cohort
  WOOFZ_K9_BL_3 = 'woofz_k9_bl_3', // OCS testing cohort
  WOOFZ_K9_DRSL = 'woofz_k9_drsl',
  WOOFZ_PPDAY_65 = 'woofz_ppday_65',
  WOOFZ_PPDAY_70 = 'woofz_ppday_70',
  WOOFZ_PPDAY_75 = 'woofz_ppday_75',
  WOOFZ_PPDAY_80 = 'woofz_ppday_80',
  WOOFZ_WA1 = 'woofz_wa1',
  WOOFZ_OFFER1_65 = 'woofz_offer1_65',
  WOOFZ_OFFER1_70 = 'woofz_offer1_70',
  WOOFZ_OFFER1_75 = 'woofz_offer1_75',
  WOOFZ_OFFER1_80 = 'woofz_offer1_80',
  WOOFZ_OFFER2_70 = 'woofz_offer2_70',
  WOOFZ_OFFER2_75 = 'woofz_offer2_75',
  WOOFZ_XMAS_65 = 'woofz_xmas_65',
  WOOFZ_XMAS_70 = 'woofz_xmas_70',
  WOOFZ_XMAS_80 = 'woofz_xmas_80',
  WOOFZ_VDAY_65 = 'woofz_vday_65',
  WOOFZ_VDAY_70 = 'woofz_vday_70',
  WOOFZ_VDAY_75 = 'woofz_vday_75',
  WOOFZ_VDAY_80 = 'woofz_vday_80',
  WOOFZ_HLWN_65 = 'woofz_hlwn_65',
  WOOFZ_HLWN_70 = 'woofz_hlwn_70',
  WOOFZ_HLWN_75 = 'woofz_hlwn_75',
  WOOFZ_HLWN_80 = 'woofz_hlwn_80',
  WOOFZ_SUB_CNLD_70 = 'woofz_sub_cnld_70',
  WOOFZ_NDD = 'woofz_ndd',
  WOOFZ_NDD_65 = 'woofz_ndd_65',
  WOOFZ_NDD_70 = 'woofz_ndd_70',
  WOOFZ_NDD_75 = 'woofz_ndd_75',
  WOOFZ_NDD_80 = 'woofz_ndd_80',
  WOOFZ_WOOFY1 = 'woofz_woofy1',
  WOOFZ_NRDAY_65 = 'woofz_nrday_65',
  WOOFZ_NRDAY_70 = 'woofz_nrday_70',
  WOOFZ_NRDAY_75 = 'woofz_nrday_75',
  WOOFZ_NRDAY_80 = 'woofz_nrday_80',
  WOOFZ_PUP_WT = 'woofz_pup_wt',
  WOOFZ_PUP_DRSL = 'woofz_pup_drsl',
  WOOFZ_COACHING = 'woofz_coaching',
  WOOFZ_SMD = 'woofz_smd',
  WOOFZ_SMD_BL = 'woofz_smd_bl',
  WOOFZ_PAW_NUP = 'woofz_paw_nup',
  WOOFZ22_V4_BG = 'woofz22_v4_bg',
  WOOFZ_PT1_BG = 'woofz_pt1_bg',
  WOOFZ_K9_BL_BG = 'woofz_k9_bl_bg',
}

export const FULLY_NEW_SUBSCRIPTIONS_COHORTS: Cohort[] = [
  Cohort.WOOFZ22_V9,
  Cohort.WOOFZ_PN,
  Cohort.WOOFZ22_V4L,
  Cohort.WOOFZ22_V4_WT,
  Cohort.WOOFZ_ESA,
  Cohort.WOOFZ_WS2,
  Cohort.WOOFZ_VGS,
  Cohort.WOOFZ_RFND3_ND,
  Cohort.WOOFZ_VC6,
  Cohort.WOOFZ22_V3,
  Cohort.WOOFZ_PT1,
  Cohort.WOOFZ22_V4,
  Cohort.WOOFZ_RFND3,
  Cohort.WOOFZ_PPP,
  Cohort.WOOFZ_PPP_BL,
  Cohort.WOOFZ_PPP_WOOFY,
  Cohort.WOOFZ_PUP,
  Cohort.WOOFZ_PUP_BL,
  Cohort.WOOFZ_LOVE,
  Cohort.WOOFZ_RT,
  Cohort.WOOFZ22_V4T,
  Cohort.WOOFZ_LOVE_BL,
  Cohort.WOOFZ_INVX,
  Cohort.WOOFZ_EASTER_65,
  Cohort.WOOFZ_EASTER_70,
  Cohort.WOOFZ_EASTER_75,
  Cohort.WOOFZ_EASTER_80,
  Cohort.WOOFZ_S1_6_12,
  Cohort.WOOFZ_S2_6_12,
  Cohort.WOOFZ_S3_6_12,
  Cohort.WOOFZ_K9,
  Cohort.WOOFZ_NPDAY_65,
  Cohort.WOOFZ_NPDAY_70,
  Cohort.WOOFZ_NPDAY_75,
  Cohort.WOOFZ_NPDAY_80,
  Cohort.WOOFZ_K9_BL,
  Cohort.WOOFZ_K9_BL_1,
  Cohort.WOOFZ_K9_BL_2,
  Cohort.WOOFZ_K9_BL_3,
  Cohort.WOOFZ_K9_DRSL,
  Cohort.WOOFZ_PPDAY_65,
  Cohort.WOOFZ_PPDAY_70,
  Cohort.WOOFZ_PPDAY_75,
  Cohort.WOOFZ_PPDAY_80,
  Cohort.WOOFZ_WA1,
  Cohort.WOOFZ_OFFER1_65,
  Cohort.WOOFZ_OFFER1_70,
  Cohort.WOOFZ_OFFER1_75,
  Cohort.WOOFZ_OFFER1_80,
  Cohort.WOOFZ_OFFER2_70,
  Cohort.WOOFZ_OFFER2_75,
  Cohort.WOOFZ_XMAS_65,
  Cohort.WOOFZ_XMAS_70,
  Cohort.WOOFZ_XMAS_80,
  Cohort.WOOFZ_VDAY_65,
  Cohort.WOOFZ_VDAY_70,
  Cohort.WOOFZ_VDAY_75,
  Cohort.WOOFZ_VDAY_80,
  Cohort.WOOFZ_HLWN_65,
  Cohort.WOOFZ_HLWN_70,
  Cohort.WOOFZ_HLWN_75,
  Cohort.WOOFZ_HLWN_80,
  Cohort.WOOFZ_SUB_CNLD_70,
  Cohort.WOOFZ_NDD,
  Cohort.WOOFZ_NDD_65,
  Cohort.WOOFZ_NDD_70,
  Cohort.WOOFZ_NDD_75,
  Cohort.WOOFZ_NDD_80,
  Cohort.WOOFZ_WOOFY1,
  Cohort.WOOFZ_NRDAY_65,
  Cohort.WOOFZ_NRDAY_70,
  Cohort.WOOFZ_NRDAY_75,
  Cohort.WOOFZ_NRDAY_80,
  Cohort.WOOFZ_PUP_WT,
  Cohort.WOOFZ_PUP_DRSL,
  Cohort.WOOFZ_COACHING,
  Cohort.WOOFZ_SMD,
  Cohort.WOOFZ_SMD_BL,
  Cohort.WOOFZ_PAW_NUP,
  Cohort.WOOFZ22_V4_BG,
  Cohort.WOOFZ_PT1_BG,
  Cohort.WOOFZ_K9_BL_BG,
]

export const enum PaymentSystem {
  PAYPAL = 'paypal',
  STRIPE = 'stripe',
  STRIPE_CS = 'stripe-cs',
  STRIPE_PAYPAL = 'stripe-paypal',
}

export const enum Currency {
  USD = 'USD',
  EUR = 'EUR',
  GBP = 'GBP',
  MXN = 'MXN',
  BRL = 'BRL',
  CAD = 'CAD',
  AUD = 'AUD',
}

// Prices in these currencies are too wide for the single-row plan layout,
// so the plan card stacks the old and current price instead
export const LOCAL_PRICE_LAYOUT_CURRENCIES: Currency[] = [
  Currency.MXN,
  Currency.BRL,
]

export const CURRENCY_SIGN_MAP = {
  [Currency.USD]: '$',
  [Currency.EUR]: '€',
  [Currency.GBP]: '£',
  [Currency.MXN]: '$',
  [Currency.BRL]: 'R$',
  [Currency.CAD]: 'C$',
  [Currency.AUD]: 'A$',
}

export const enum ProcessingKey {
  CREATE_CHECKOUT_SESSION = 'CREATE_CHECKOUT_SESSION',
  FETCH_PLANS = 'FETCH_PLANS',
  GET_FIRST_LEAD = 'GET_FIRST_LEAD',
  FETCH_LEAD = 'FETCH_LEAD',
  UPDATE_LEAD_WITH_EMAIL = 'UPDATE_LEAD_WITH_EMAIL',
  CREATE_LEAD = 'CREATE_LEAD',
  CREATE_COHORT_LEAD = 'CREATE_COHORT_LEAD',
  FETCH_BREEDS = 'FETCH_BREEDS',
  FETCH_COMMANDS = 'FETCH_COMMANDS',
  CREATE_USER_ACCOUNT = 'CREATE_USER_ACCOUNT',
  SAVE_USER_ANSWER = 'SAVE_USER_ANSWER',
  CREATE_FIREBASE_USER_WITH_EMAIL_AND_PASSWORD = 'CREATE_FIREBASE_USER_WITH_EMAIL_AND_PASSWORD',
  PURCHASE_PAYPAL = 'PURCHASE_PAYPAL',
  PURCHASE_STRIPE = 'PURCHASE_STRIPE',
  PURCHASE_PAYPAL_PENDING = 'PURCHASE_PAYPAL_PENDING',
  PURCHASE_STRIPE_PENDING = 'PURCHASE_STRIPE_PENDING',
  PURCHASE_FIRST_UPSELL = 'PURCHASE_FIRST_UPSELL',
  PURCHASE_FIRST_UPSELL_PENDING = 'PURCHASE_FIRST_UPSELL_PENDING',
  PURCHASE_UPSELL = 'PURCHASE_UPSELL',
  PURCHASE_UPSELL_PENDING = 'PURCHASE_UPSELL_PENDING',
  PURCHASE_CHAT_UPSELL = 'PURCHASE_CHAT_UPSELL',
  PURCHASE_CHAT_UPSELL_PENDING = 'PURCHASE_CHAT_UPSELL_PENDING',
  FETCH_PREDICTED_LTV = 'FETCH_PREDICTED_LTV',
  FETCH_GEO_DATA = 'FETCH_GEO_DATA',
  SEND_INFO_TO_GOOGLE_SHEET_INVOXIA = 'SEND_INFO_TO_GOOGLE_SHEET_INVOXIA',
  AUTOMATION_WOOFY_CHAT_START = 'AUTOMATION_WOOFY_CHAT_START',
  AUTOMATION_WOOFY_STORE_CREATIVE = 'AUTOMATION_WOOFY_STORE_CREATIVE',
  AUTOMATION_WOOFY_STORE_QUIZ = 'AUTOMATION_WOOFY_STORE_QUIZ',
  AUTOMATION_WOOFY_GET_CREATIVE = 'AUTOMATION_WOOFY_GET_CREATIVE',
  ENSURE_WOOFY_CONVERSATION = 'ENSURE_WOOFY_CONVERSATION',
  STORE_WOOFY_CONVERSATION = 'STORE_WOOFY_CONVERSATION',
  GET_DOG_PROFILE = 'GET_DOG_PROFILE',
  GET_DOGS_PROFILE = 'GET_DOGS_PROFILE',
  GET_USER_HAS_CHAT = 'GET_USER_HAS_CHAT',
  PURCHASE_UPSELL_BATCH = 'PURCHASE_UPSELL_BATCH',
}

export const enum GlobalError {
  COMMON_ERROR = 'something went wrong',
  USER_HAS_NEW_SUBSCRIPTION_ERROR = 'error during the purchase process',
  USER_HAS_EXPIRED_TOKEN_ERROR = 'user has expired token',
  COMMON_PURCHASE_ERROR = 'something went wrong in purchase',
  PURCHASE_PLAN_RESPONSE_ERROR = 'something went wrong in PurchasePlanResponse',
  PURCHASE_UPSELL_RESPONSE_ERROR = 'something went wrong in PurchaseUpsellResponse',
  PURCHASE_CHAT_UPSELL_RESPONSE_ERROR = 'something went wrong in PurchaseChatUpsellResponse',
}

export const enum InputValidationText {
  EMAIL_EXISTS = 'account.accountAlreadyExist',
  INVALID_EMAIL = 'onboarding.email.validation',
  INVALID_EMAIL_VARIANT_2 = 'onboarding.email.validationTypo',
  EMPTY_EMAIL_ERROR = 'Please, provide your email that we can send you the training plan',
  SHORT_PASSWORD = 'account.shortPassword',
  WRONG_CONFIRMATION_PASSWORD = 'account.notEqualPassword',
  WRONG_PASSWORD = 'The password you entered is incorrect',
  WRONG_EMAIL = 'The email you entered is incorrect',
  INVALID_TEXT = `Your input doesn't look valid. Please, check`,
}

export const EMAIL_DOMAINS = [
  '@gmail.com',
  '@hotmail.com',
  '@yahoo.com',
  '@outlook.com',
  '@aol.com',
  '@icloud.com',
  '@live.com',
  '@msn.com',
  '@me.com',
  '@mac.com',
  '@googlemail.com',
  '@facebook.com',
  '@verizon.net',
  '@rediffmail.com',
  '@zohomail.com',
  '@zoho.com',
  '@mail.com',
]

export const enum HeaderId {
  TITLE_MENU = 'title_menu',
  BACK_TITLE = 'back_title',
  BACK_TITLE_MENU = 'back_title_menu',
  BACK_PROGRESS_MENU = 'back_progress_menu',
  BACK_MENU = 'back_menu',
  BACK_LOGO_TITLE_MENU = 'back_logo_title_menu',
  LOGO_TITLE_MENU = 'logo_title_menu',
  LOGO_TITLE_UPSELL = 'logo_title_upsell',
}

export const WOOFZ_VC6 = 'woofz_vc6'
export const WOOFZ_COACHING = 'woofz_coaching'
export const FIREBASE_TOKEN_SEARCH_PARAM = 'token'

export const COHORTS_REQUIRING_FIREBASE_TOKEN: Cohort[] = [
  Cohort.WOOFZ_VC6,
  Cohort.WOOFZ_COACHING,
  Cohort.WOOFZ_WA1,
]

export const COHORTS_PRESERVE_SUBSCRIPTIONS_ON_CREATE_COHORT_LEAD: Cohort[] = [
  Cohort.WOOFZ_VC6,
  Cohort.WOOFZ_COACHING,
  Cohort.WOOFZ_WA1,
]

export const VC_COHORTS = [WOOFZ_VC6, WOOFZ_COACHING]

export const TALKJS_APP_ID_MAP: Record<CurrentEnvironment, string> = {
  [CurrentEnvironment.DEV]: 'twbMxsZr',
  [CurrentEnvironment.STAGE]: 'twbMxsZr',
  [CurrentEnvironment.PROD]: 'bugRgWN1',
  [CurrentEnvironment.DEV02]: 'twbMxsZr',
  [CurrentEnvironment.STAGE_QA]: 'twbMxsZr',
}

export const AUTOMATION_API_START_WOOFY_CHAT_URL_MAP: Record<
  CurrentEnvironment,
  string
> = {
  [CurrentEnvironment.DEV]: 'automation.nove8.com/webhook/woofy/chat/start',
  [CurrentEnvironment.STAGE]: 'automation.nove8.com/webhook/woofy/chat/start',
  [CurrentEnvironment.PROD]:
    'automation.nove8.com/webhook/woofy/chat/start/live',
  [CurrentEnvironment.DEV02]: 'automation.nove8.com/webhook/woofy/chat/start',
  [CurrentEnvironment.STAGE_QA]:
    'automation.nove8.com/webhook/woofy/chat/start',
}

export const AUTOMATION_API_START_WOOFY_CHAT_URL_MAP_V2: Record<
  CurrentEnvironment,
  string
> = {
  [CurrentEnvironment.DEV]: 'automation.nove8.com/webhook/woofy/v2/chat/start',
  [CurrentEnvironment.STAGE]:
    'automation.nove8.com/webhook/woofy/v2/chat/start',
  [CurrentEnvironment.PROD]:
    'automation.nove8.com/webhook/woofy/v2/chat/start/live',
  [CurrentEnvironment.DEV02]:
    'automation.nove8.com/webhook/woofy/v2/chat/start',
  [CurrentEnvironment.STAGE_QA]:
    'automation.nove8.com/webhook/woofy/v2/chat/start',
}

export type TWoofyChatApiVersion = 'v1' | 'v2'

export const DEFAULT_WOOFY_CHAT_API_VERSION: TWoofyChatApiVersion = 'v1'

export const REFUND_CONTACT_US_LINK =
  'https://account.nove8.com/woofz/refund-contact-us'

export const COUNTRIES_WITH_MANAGE_SUBSCRIPTION_BUTTON = [
  'AT',
  'BE',
  'BG',
  'HR',
  'CY',
  'CZ',
  'DK',
  'EE',
  'FI',
  'FR',
  'DE',
  'GR',
  'HU',
  'IE',
  'IT',
  'LV',
  'LT',
  'LU',
  'MT',
  'NL',
  'PL',
  'PT',
  'RO',
  'SK',
  'SI',
  'ES',
  'SE',
  'NO',
  'IS',
  'CH',
  'LI',
]

export const CALENDLY_URI = 'CALENDLY_URI'
export const USER_EMAIL = 'USER_EMAIL'
export const IS_USER_HAS_SUBSCRIPTION = 'IS_USER_HAS_SUBSCRIPTION'

export const NO_ISSUES_VARIANTS = [
  'No issues',
  'Not sure',
  'No signs of anxiety',
  'No, everything’s good',
]

export const BEHAVIOR_OPTIONS_WITH_DOG_AGE_MAP = {
  [DOG_AGE_STAGE_OPTIONS.YOUNGER_THEN_SIX_MONTH]: [
    {
      translationKey: BEHAVIOR_OPTIONS.BITTING_NIPPING,
      savedAnswer: 'biting',
    },
    {
      translationKey: BEHAVIOR_OPTIONS.HOME_SETUP,
      savedAnswer: 'home_setup',
    },
    {
      translationKey: BEHAVIOR_OPTIONS.COMMAND_TRAINING,
      savedAnswer: 'commands',
    },
    {
      translationKey: BEHAVIOR_OPTIONS.POTTY_TRAINING,
      savedAnswer: 'potty_issues',
    },
    {
      translationKey: BEHAVIOR_OPTIONS.DESTRUCTIVE_CHEWING,
      savedAnswer: 'chewing',
    },
    {
      translationKey: BEHAVIOR_OPTIONS.RESTLESSNESS_ANXIETY,
      savedAnswer: 'generalanxiety',
    },
    {
      translationKey: BEHAVIOR_OPTIONS.ANXIETY_WHEN_ALONE,
      savedAnswer: 'separation_anxiety',
    },
    {
      translationKey: BEHAVIOR_OPTIONS.COMING_WHEN_I_CALL,
      savedAnswer: 'recall',
    },
    {
      translationKey: BEHAVIOR_OPTIONS.BARKING_DOG,
      savedAnswer: 'barking',
    },
    {
      translationKey: BEHAVIOR_OPTIONS.LEASH_PULLING,
      savedAnswer: 'leash_pulling',
    },
    {
      translationKey: BEHAVIOR_OPTIONS.JUMPING_2,
      savedAnswer: 'jumping',
    },
    {
      translationKey: BEHAVIOR_OPTIONS.DIET_NUTRITION,
      savedAnswer: 'nutrition',
    },
    {
      translationKey: BEHAVIOR_OPTIONS.HANDLING_GROOMING_ANXIETY,
      savedAnswer: 'grooming_anxiety',
    },
    {
      translationKey: BEHAVIOR_OPTIONS.CHASING_MOVING_THINGS,
      savedAnswer: 'chasing',
    },
    {
      translationKey: BEHAVIOR_OPTIONS.REACTIVITY_TO_DOGS_PEOPLE,
      savedAnswer: 'reactivity',
    },
    {
      translationKey: BEHAVIOR_OPTIONS.BUILD_BOND_TRUST,
      savedAnswer: 'trust_issues',
    },
  ],

  [DOG_AGE_STAGE_OPTIONS.SIX_TWELVE_MONTHS]: [
    {
      translationKey: BEHAVIOR_OPTIONS.REACTIVITY_TO_DOGS_PEOPLE,
      savedAnswer: 'reactivity',
    },
    {
      translationKey: BEHAVIOR_OPTIONS.COMMAND_TRAINING,
      savedAnswer: 'commands',
    },
    {
      translationKey: BEHAVIOR_OPTIONS.BITTING_NIPPING,
      savedAnswer: 'biting',
    },
    {
      translationKey: BEHAVIOR_OPTIONS.LEASH_PULLING,
      savedAnswer: 'leash_pulling',
    },
    {
      translationKey: BEHAVIOR_OPTIONS.COMING_WHEN_I_CALL,
      savedAnswer: 'recall',
    },
    {
      translationKey: BEHAVIOR_OPTIONS.BARKING_DOG,
      savedAnswer: 'barking',
    },
    {
      translationKey: BEHAVIOR_OPTIONS.DESTRUCTIVE_CHEWING,
      savedAnswer: 'chewing',
    },
    {
      translationKey: BEHAVIOR_OPTIONS.DIET_NUTRITION,
      savedAnswer: 'nutrition',
    },
    {
      translationKey: BEHAVIOR_OPTIONS.POTTY_TRAINING,
      savedAnswer: 'potty_issues',
    },
    {
      translationKey: BEHAVIOR_OPTIONS.RESTLESSNESS_ANXIETY,
      savedAnswer: 'generalanxiety',
    },
    {
      translationKey: BEHAVIOR_OPTIONS.ANXIETY_WHEN_ALONE,
      savedAnswer: 'separation_anxiety',
    },
    {
      translationKey: BEHAVIOR_OPTIONS.JUMPING_2,
      savedAnswer: 'jumping',
    },
    {
      translationKey: BEHAVIOR_OPTIONS.CHASING_MOVING_THINGS,
      savedAnswer: 'chasing',
    },
    {
      translationKey: BEHAVIOR_OPTIONS.BUILD_BOND_TRUST,
      savedAnswer: 'trust_issues',
    },
  ],

  [DOG_AGE_STAGE_OPTIONS.ONE_TWO_YEAR]: [
    {
      translationKey: BEHAVIOR_OPTIONS.RESTLESSNESS_ANXIETY,
      savedAnswer: 'generalanxiety',
    },
    {
      translationKey: BEHAVIOR_OPTIONS.ANXIETY_WHEN_ALONE,
      savedAnswer: 'separation_anxiety',
    },
    {
      translationKey: BEHAVIOR_OPTIONS.BARKING_DOG,
      savedAnswer: 'barking',
    },
    {
      translationKey: BEHAVIOR_OPTIONS.LEASH_PULLING,
      savedAnswer: 'leash_pulling',
    },
    {
      translationKey: BEHAVIOR_OPTIONS.REACTIVITY,
      savedAnswer: 'reactivity',
    },
    {
      translationKey: BEHAVIOR_OPTIONS.COMING_WHEN_I_CALL,
      savedAnswer: 'recall',
    },
    {
      translationKey: BEHAVIOR_OPTIONS.COMMAND_TRAINING,
      savedAnswer: 'commands',
    },
    {
      translationKey: BEHAVIOR_OPTIONS.JUMPING_2,
      savedAnswer: 'jumping',
    },
    {
      translationKey: BEHAVIOR_OPTIONS.POTTY_TRAINING,
      savedAnswer: 'potty_issues',
    },
    {
      translationKey: BEHAVIOR_OPTIONS.BITTING_NIPPING,
      savedAnswer: 'biting',
    },
    {
      translationKey: BEHAVIOR_OPTIONS.DESTRUCTIVE_CHEWING,
      savedAnswer: 'chewing',
    },
    {
      translationKey: BEHAVIOR_OPTIONS.DIET_NUTRITION,
      savedAnswer: 'nutrition',
    },
    {
      translationKey: BEHAVIOR_OPTIONS.FOOD_TOY_GUARDING,
      savedAnswer: 'resource_guarding',
    },
    {
      translationKey: BEHAVIOR_OPTIONS.BUILD_BOND_TRUST,
      savedAnswer: 'trust_issues',
    },
  ],

  [DOG_AGE_STAGE_OPTIONS.TWO_SEVEN_YEARS]: [
    {
      translationKey: BEHAVIOR_OPTIONS.BARKING_DOG,
      savedAnswer: 'barking',
    },
    {
      translationKey: BEHAVIOR_OPTIONS.RESTLESSNESS_ANXIETY,
      savedAnswer: 'generalanxiety',
    },
    {
      translationKey: BEHAVIOR_OPTIONS.LEASH_PULLING,
      savedAnswer: 'leash_pulling',
    },
    {
      translationKey: BEHAVIOR_OPTIONS.REACTIVITY_TO_DOGS_PEOPLE,
      savedAnswer: 'reactivity',
    },
    {
      translationKey: BEHAVIOR_OPTIONS.COMING_WHEN_I_CALL,
      savedAnswer: 'recall',
    },
    {
      translationKey: BEHAVIOR_OPTIONS.COMMAND_TRAINING,
      savedAnswer: 'commands',
    },
    {
      translationKey: BEHAVIOR_OPTIONS.BUILD_BOND_TRUST,
      savedAnswer: 'trust_issues',
    },
    {
      translationKey: BEHAVIOR_OPTIONS.JUMPING_2,
      savedAnswer: 'jumping',
    },
    {
      translationKey: BEHAVIOR_OPTIONS.FOOD_TOY_GUARDING,
      savedAnswer: 'resource_guarding',
    },
    {
      translationKey: BEHAVIOR_OPTIONS.DESTRUCTIVE_CHEWING,
      savedAnswer: 'chewing',
    },
    {
      translationKey: BEHAVIOR_OPTIONS.ANXIETY_WHEN_ALONE,
      savedAnswer: 'separation_anxiety',
    },
    {
      translationKey: BEHAVIOR_OPTIONS.DIET_NUTRITION,
      savedAnswer: 'nutrition',
    },
  ],

  [DOG_AGE_STAGE_OPTIONS.MORE_THAN_SEVEN_YEARS]: [
    {
      translationKey: BEHAVIOR_OPTIONS.BARKING_DOG,
      savedAnswer: 'barking',
    },
    {
      translationKey: BEHAVIOR_OPTIONS.RESTLESSNESS_ANXIETY,
      savedAnswer: 'generalanxiety',
    },
    {
      translationKey: BEHAVIOR_OPTIONS.REACTIVITY_TO_DOGS_PEOPLE,
      savedAnswer: 'reactivity',
    },
    {
      translationKey: BEHAVIOR_OPTIONS.BUILD_BOND_TRUST,
      savedAnswer: 'trust_issues',
    },
    {
      translationKey: BEHAVIOR_OPTIONS.POTTY_ACCIDENTS,
      savedAnswer: 'potty_issues',
    },
    {
      translationKey: BEHAVIOR_OPTIONS.DIET_NUTRITION,
      savedAnswer: 'nutrition',
    },
    {
      translationKey: BEHAVIOR_OPTIONS.MEMORY_CONFUSION_ISSUES,
      savedAnswer: 'memory_issues',
    },
    {
      translationKey: BEHAVIOR_OPTIONS.LEASH_PULLING,
      savedAnswer: 'leash_pulling',
    },
    {
      translationKey: BEHAVIOR_OPTIONS.FOOD_TOY_GUARDING,
      savedAnswer: 'resource_guarding',
    },
  ],
}

export const COHORTS_WITH_NEW_APPLOVIN_EVENTS = [
  Cohort.WOOFZ_K9_BL,
  Cohort.WOOFZ_K9,
]
